export const EXPAND_HTML_EVENT = {
    toggle: 'expand-html:toggle',
}
